import { Component } from '@angular/core';
import { BaseSiteService, CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';

@Component({
    selector: 'app-help-section-dashboard',
    templateUrl: './help-section-dashboard.component.html',
    styleUrls: ['./help-section-dashboard.component.scss'],
    standalone: false
})
export class HelpSectionDashboardComponent {
  currentSite: string | undefined;
  constructor(public component: CmsComponentData<CmsBannerComponent>,public contentService:ContentService,private baseSiteService:BaseSiteService, protected config: OccConfig) {

  }
  bannerNode: Observable<any> = this.component.data$;
  vssdata: any;
  // vssdata:Observable<any> = this.contentService.vsscontent();
  ngOnInit(){
    this.baseSiteService.getActive().subscribe(res => {
      this.currentSite = res;
    });
    this.contentService.vsscontent().subscribe(value => { 
      this.vssdata = value;
      this.contentService.setCalendlyData(this.vssdata);
    })
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }
}
